// extracted by mini-css-extract-plugin
export default {"gallery":"c-o_hs","gallery__header":"c-o_ht","gallery__thumbs":"c-o_hu"};